import { MusicStateToggleButton } from './MusicStateToggleButton';
import { ActionStateToggleButtonProps } from './types';
import { useBackgroundMusicPlayback } from './useBackgroundMusicPlayback';

export type ActionStateToggleButtonWrapperProps = Pick<ActionStateToggleButtonProps, 'className'>;

export function MusicStateToggleButtonWrapper(props: ActionStateToggleButtonWrapperProps) {
  const { currentMusicState, toggleMusic, isToneLoading } = useBackgroundMusicPlayback();
  return (
    <MusicStateToggleButton
      {...props}
      currentActionState={currentMusicState}
      onClick={toggleMusic}
      isToneLoading={isToneLoading}
    />
  );
}
